import { render, staticRenderFns } from "./shipper.vue?vue&type=template&id=21db81f1&"
import script from "./shipper.vue?vue&type=script&lang=js&"
export * from "./shipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21db81f1')) {
      api.createRecord('21db81f1', component.options)
    } else {
      api.reload('21db81f1', component.options)
    }
    module.hot.accept("./shipper.vue?vue&type=template&id=21db81f1&", function () {
      api.rerender('21db81f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/shipper.vue"
export default component.exports